import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";

const BreadcrumbSchema = () => {
  const location = useLocation();

  const baseUrl = "https://www.rain.one";
  const pathnames = location.pathname.split("/").filter(Boolean);

  const itemListElement = [
    {
      "@type": "ListItem",
      position: 1,
      name: "Home",
      item: baseUrl + "/",
    },
  ];

  pathnames.forEach((value, index) => {
    const url = `${baseUrl}/${pathnames.slice(0, index + 1).join("/")}`;
    itemListElement.push({
      "@type": "ListItem",
      position: index + 2,
      name: value.charAt(0).toUpperCase() + value.slice(1),
      item: url,
    });
  });

  const schema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement,
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};

export default BreadcrumbSchema;